module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fhd1"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _vm._v("Enthusiastic Praise for")]), _vm._v(" "), _c('p', {
    staticClass: "fhd2"
  }, [_vm._v("BARBARA DELINSKY")]), _vm._v(" "), _c('p', {
    staticClass: "fpara"
  }, [_vm._v("“One of today’s quintessential authors of contemporary fiction … Ms. Delinsky is a joy to read. With the incisive skill of a surgeon and the delicate insight of true compassion, she deeply probes the quality and meaning of life. Women’s fiction at its very finest.”")]), _vm._v(" "), _c('p', {
    staticClass: "fright"
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Romantic Times")])]), _vm._v(" "), _c('p', {
    staticClass: "fpara"
  }, [_vm._v("“[An author] of sensitivity and style.”")]), _vm._v(" "), _c('p', {
    staticClass: "fright"
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Publishers Weekly")])]), _vm._v(" "), _c('p', {
    staticClass: "fpara"
  }, [_vm._v("“Ms. Delinsky has a special knack for zeroing in on the pulse of her characters immediately—we know them and understand what makes them tick within the first few pages…. Well done!”")]), _vm._v(" "), _c('p', {
    staticClass: "fright"
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rendezvous")])]), _vm._v(" "), _c('p', {
    staticClass: "fpara"
  }, [_vm._v("“When you care enough to read the very best, the name of Barbara Delinsky should come immediately to mind…. One of the few writers … who still writes a great love story, Ms. Delinsky is truly an author for all seasons.”")]), _vm._v(" "), _c('p', {
    staticClass: "fright"
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rave Reviews")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-98c29092","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/02_Front1.vue
// module id = 69
// module chunks = 0